import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { useFlexLayout } from 'react-table';
import './style.css';

const useStyles = makeStyles((theme) => ({
    button: {
        margin: '0px 0px 0px 16px !important',
        background: '#4c4fa6 !important',
        color: 'white !important',
        padding: '6px 40px !important',
        // fontFamily: 'Rubik' !important',
        textTransform: 'none !important',
    },
    fontFamilyRubik: {
        fontFamily: 'Rubik !important',
    },
    btnPrivacy: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
    txtJustify: {
        textAlign: 'justify',
    },
}));

export default function Policy({ text, showDialogBox, handlePolicyClose, callConfirmation }) {
    const classes = useStyles();
    // const handleClose = () => {
    //     callClose();
    // };
    // const handleOk = () => {
    //     callConfirmation();
    // };
    const [maxWidth, setMaxWidth] = React.useState('md');
    const [fullWidth, setFullWidth] = React.useState(true);
    return (
        <>
            <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={showDialogBox}
                onClose={() => handlePolicyClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
                disableBackdropClick
            >
                <DialogTitle style={{ fontFamily: 'Rubik' }} id="alert-dialog-title">
                    Data Protection & Privacy Policy (“Policy”)
                </DialogTitle>
                <DialogContent className={classes.txtJustify}>
                    <DialogContentText id="alert-dialog-description" className={classes.fontFamilyRubik} style={{ fontFamily: 'Rubik' }}>
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Advith ITeC Pvt. Ltd. (“Advith ITeC” or “we” or “us”) is engaged in the business of providing tech enabled
                            business support service relating to financial service requirements of its customers (“Services”) through the
                            software, developed and owned by Advith ITeC under the name and style - “Advith ITeC Platform”. The Services are
                            provided through the online Website of Advith ITeC– www.advithitec.in including all its sub-domains (“Website”).
                            The clients of the Customers (“Clients”) and their staff/consultant/employees and the staff/consultant/employees
                            of the Customers including the representative of the Customer accessing the Website are referred to as the
                            “Users” of the Website or “you” or “your”. The term “Customer” here refers to the customer of Advith ITeC who
                            has entered into a software license cum service agreement with Advith ITeC.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            The Users shall read these Terms carefully before using the Website.
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            This Policy describes the practices adopted by Advith ITeC in connection with information collected by Advith
                            ITeC belonging to the Users while providing the Services. By providing Data (as defined herein) to Advith ITeC
                            through any of the Services, Users agree to the terms and conditions of this Policy.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className="fontFamilyRubik fW600">
                            Policy elements
                        </Typography>
                        <br />
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            As part of our Services, we need to obtain and process information (“Data”). This Data includes any offline or
                            online data that makes a person identifiable such as names, addresses, usernames and passwords, bank accounts,
                            digital footprints and financial data etc., and in case of a legal entity, such information including financial
                            statements, details of creditors, vendors, suppliers, salary packages, etc. Our system collects this information
                            in a transparent way and only with the full cooperation and knowledge of the Users. Once this information is
                            available to us, the following rules apply.
                        </Typography>
                        <br />
                        <Typography variant="subtitle1" className="fontFamilyRubik fW600">
                            Data will be:
                        </Typography>
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            <ul>
                                <li>Collected fairly and for lawful purposes only;</li>
                                <li>
                                    Processed by Advith ITeC within its legal and moral boundaries for the purpose of providing the
                                    Services;
                                </li>
                                <li>Protected against any unauthorized or illegal access by internal or external parties.</li>
                            </ul>
                            By submitting your Data to us, you agree to the processing set out in this Policy. Further notices highlighting
                            certain uses we wish to make of your Data together with the ability to opt in or out of selected uses may also
                            be provided to you when we collect Data from you.
                            <ul className="pl-15 fW600">
                                <li>Your rights</li>
                            </ul>
                            By accessing Website, you are consenting to our collecting, storing, sharing and processing of the Data as per
                            the terms and conditions stated herein.
                            <ol>
                                <li>
                                    You may, after giving your consent to receive and process your Data and information on Website, withdraw
                                    such consent at a subsequent stage. Any such withdrawal of consent from you shall need to be sent in
                                    writing to our Grievance Officer at the details mentioned at the end of this Policy. If you choose not
                                    to provide Data or subsequently withdraw your consent, we may not be able to provide you access to
                                    Website. Withdrawing your consent will neither affect the lawfulness of any processing conducted prior
                                    to your withdrawal, nor will it affect processing of your Data conducted in reliance on lawful
                                    processing grounds other than consent nor will it affect any statutory requirement on Advith ITeC to
                                    retain such Data post withdrawal of your consent.
                                </li>
                                <li>
                                    You may unsubscribe from our marketing communications by clicking on the “unsubscribe” link located on
                                    the bottom of our e-mails, updating your communication preferences, or by sending us email to
                                    support@advithitec.in
                                </li>
                                <li>
                                    You shall be permitted, as and when requested by you, to review the Data which you had provided. If you
                                    find any inaccuracy or deficiency, you may ask for corrections to be made and Advith ITeC will try to
                                    accommodate your request to the extent feasible. Advith ITeC shall at no point in time be responsible
                                    for any inaccurate information provided by Users.
                                </li>
                            </ol>
                            <ul className="pl-15 fW600">
                                <li>Cookies</li>
                            </ul>
                            “Cookies” are small text files that are stored on your computer or other device when you visit certain online
                            pages that record your preferences and actions. Advith ITeC uses cookies and other technologies to, among other
                            things, better serve the Users with more tailored information and facilitate their ongoing access to and use of
                            the Services. Users can instruct their browser to reject all cookies or indicate when a cookie is sent. However,
                            if Users do not accept cookies, they may not be able to use some features of the Website.
                            <ul className="pl-15 fW600">
                                <li>Data we collect</li>
                            </ul>
                            Advith ITeC collects the following Data from the Users depending on the Services availed from them through
                            Advith ITeC-
                            <ol>
                                <li>
                                    Personally identifiable information such as User’s name, his parents’ name, date of birth, email id,
                                    phone number, educational or professional qualification, username, password, income, deductions,
                                    credits, dependents, permanent account number or bank account details, copies of KYC documents etc.
                                </li>
                                <li>
                                    Business name, business address, nature of business, financial statements, Goods and Services Tax
                                    Identification Number, Tax Deduction and Collection Account Number, details of vendors, suppliers,
                                    creditors etc.
                                </li>
                                <li>
                                    User’s internet protocol address, the links you select or actions you take, browser type, the unique
                                    identifier of your device and device information such as operating system, operating system version,
                                    browser plug-ins, crashes, system activity, hardware settings, location based information, date and time
                                    of your request and referral URL, and cookies that may uniquely identify your browser and mobile
                                    application and the previously visited webpage.
                                </li>
                                <li>Any other data uploaded by user or customer during the course of usage of the software.</li>
                            </ol>
                            <ul className="pl-15 fW600">
                                <li>How we use Data</li>
                            </ul>
                            Data is used in the following manner:
                            <ol>
                                <li>To provide the Services.</li>
                                <li>
                                    To respond to enquiries and fulfill the requests of the Users, such as to send them email invites,
                                    respond to questions/comments, etc.
                                </li>
                                <li>
                                    To send Users administrative information that may be important for the use of the Services that they may
                                    not opt out of receiving, for e.g., information regarding the Services, changes made to the terms,
                                    conditions and policies, updates, etc.
                                </li>
                                <li>To contact the Users or even re-contact them if Advith ITeC has not heard from them in a while.</li>
                                <li> To send advertising/promotional material to the Users.</li>
                                <li>
                                    {' '}
                                    For Advith ITeC’s business purposes, such as analyzing and managing their business, retargeting offers,
                                    market research, audits, developing new products, enhancing and improving the Services, identifying
                                    usage trends, determining the effectiveness of the promotional campaigns, gauging customer satisfaction
                                    and providing customer service.
                                </li>
                                <li>
                                    To communicate with you. You further expressly consent and authorise us to send you e-mails on your
                                    e-mail id, messages on your mobile number, call you on your mobile number, send you messages and
                                    communicate with you in any other manner including for the purpose of providing you Platform and
                                    Services and for marketing and promotional purposes.
                                </li>
                                <li>To provide all the services availed by you through the software.</li>
                            </ol>
                            <ul className="pl-15 fW600">
                                <li>How do we share the Data</li>
                            </ul>
                            Data will be shared in the following manner-
                            <ol>
                                <li>
                                    To third-party advertising companies to display advertisements. Such companies may use information about
                                    your visits to the website and third party platforms in order to provide advertisements about goods and
                                    services of interest to you.
                                </li>
                                <li>
                                    To third party service providers and our affiliates to host, use, copy, transmit, process, store, share,
                                    analyse, display, make derivations, and back up all Data you submit to us through our services and as
                                    required by us, for the purposes of
                                    <br />
                                    <ol type="a">
                                        <li>
                                            Providing the Services requested by you, as set out in this Policy and enable you to use the
                                            website and avail the Services (including the services provided by our service providers, third
                                            parties and affiliates;
                                        </li>
                                        <li>Allow us to improve, develop and protect our Services; </li>
                                        <li>
                                            Create, market or provide new services through Advith ITeC or its service providers, group
                                            companies and affiliates;{' '}
                                        </li>
                                        <li> Communicate with you about our Wesbite and the Services; and </li>
                                        <li>
                                            {' '}
                                            Send you information we think may be of interest to you. You agree, represent and warrant that
                                            you have, and you will maintain, all rights to allow Advith ITeC, our service providers and/ or
                                            any third-party service providers, and our affiliates, to host, use, compile, copy, transmit,
                                            process, store, share, analyse, display, make derivations, and back up all your Data and retain
                                            aggregated customer data, including without limitation in combination with data of other users.
                                        </li>
                                    </ol>
                                </li>
                                <li>
                                    To a third party in the event of any reorganization, merger, sale, joint venture, assignment, transfer
                                    or other disposition of all or any portion of Advith ITeC’s business, assets or stock (including in
                                    connection with any bankruptcy or similar proceedings);
                                </li>
                                <li>To a third party for the limited purpose of providing Services;</li>
                                <li>To its employees for the purpose of providing Services;</li>
                                <li>In the form of report generated pursuant to the Services availed by the Users;</li>
                                <li>
                                    As Advith ITeC believes to be necessary or appropriate
                                    <ol type="a">
                                        <li>Under the laws applicable and in force in India; </li>
                                        <li>To comply with legal process; </li>
                                        <li>To respond to request from public and Government Authorities;</li>
                                        <li>To enforce Advith ITeC’s terms and conditions;</li>
                                        <li>
                                            To protect Advith ITeC’s rights, privacy, safety or property and/or that of their affiliates,
                                            the Users or others;
                                        </li>
                                        <li>To protect the operations of Advith ITeC; and</li>
                                        <li>
                                            To allow Advith ITeC to pursue available remedies or limit the damages that they may sustain.
                                        </li>
                                        <li>
                                            {' '}
                                            To carry out analytics and publish reports as may be required for the business purposes of
                                            Advith ITeC.
                                        </li>
                                    </ol>
                                </li>
                            </ol>
                            <ul className="pl-15 fW600">
                                <li>How we protect and store Data</li>
                            </ul>
                            All Data gathered on Website is securely stored within Advith ITeC’s controlled database. The database is stored
                            on servers secured behind a firewall; access to such servers being password-protected and strictly limited based
                            on need-to-know basis. However, we understand that as competent as our security measures are, no security system
                            is impenetrable. Thus, we cannot guarantee the security of our database, nor can we guarantee that information
                            Users supply will not be intercepted while being transmitted to us over the Internet. Further, Advith ITeC
                            assumes no responsibility of whatsoever nature as to make good the losses and damages you may incur, due to
                            privacy and/or security breach of Data. We shall not be liable for any loss or damage sustained by reason of
                            disclosure (inadvertent or otherwise) of any information and/or omission or inaccuracy with respect to any
                            information so disclosed and used whether or not in pursuance of a legal process or otherwise.
                            <Typography variant="body2" className={classes.fontFamilyRubik}>
                                As part of Data protection, we are ensuring the data captured from the website are securely stored within
                                Azure mySQL which is SSL enabled and also encrypted. The website is hosted in Azure which is secured by
                                Azure Application Gateway WAF. Core benefits that WAF on Application Gateway provides.
                            </Typography>
                            <Typography variant="subtitle2" className={classes.fontFamilyRubik}>
                                Protection
                            </Typography>
                            <ul>
                                <li>Protect web application from web vulnerabilities and attacks without modification to back-end code.</li>
                                <li>Protect web application from malicious bots with the IP Reputation ruleset.</li>
                            </ul>
                            <Typography variant="subtitle2" className={classes.fontFamilyRubik}>
                                Monitoring
                            </Typography>
                            <ul>
                                <li>Monitor attacks against web application by using a real-time WAF log.</li>
                                <li>
                                    The Application Gateway WAF is integrated with Azure Security Center. Security Center provides a central
                                    view of the security state of all your Azure resources.
                                </li>
                            </ul>
                            <Typography variant="subtitle2" className={classes.fontFamilyRubik}>
                                Features
                            </Typography>
                            <ul>
                                <li>SQL-injection protection.</li>
                                <li>Cross-site scripting protection.</li>
                                <li>
                                    Protection against other common web attacks, such as command injection, HTTP request smuggling, HTTP
                                    response splitting, and remote file inclusion.
                                </li>
                                <li>Protection against HTTP protocol violations.</li>
                                <li>Protection against HTTP protocol anomalies, such as missing host user-agent and accept headers.</li>
                            </ul>
                            <Typography variant="body2" className={classes.fontFamilyRubik}>
                                Further, any information you include in a posting to the discussion areas will be available to anyone with
                                Internet access.
                            </Typography>
                            <Typography variant="body2" className={classes.fontFamilyRubik}>
                                You acknowledge, agree and authorise our hosting service provider,
                                <span className="fW600 fontFamilyRubik">
                                    {' '}
                                    Maveric Systems Limited, Anchorage#, 100, Richmond Rd, Bengaluru, Karnataka 560025
                                </span>{' '}
                                to collect, store, process, transfer your information including for the purpose of providing Services to you
                                through the Website. You allow such service provider to record, maintain and process your personal and
                                transaction related information for the purpose of using the Services. You further authorise such service
                                provider to communicate with you in any manner including by way of emails, messages and phone calls.
                            </Typography>
                            <ul className="pl-15 fW600">
                                <li>Opt-in and Opt Out</li>
                            </ul>
                            The Users may opt-in regarding Advith ITeC’s use and disclosure and use of their Data.
                            <ol>
                                <li>
                                    {' '}
                                    If at any time Users wish to stop receiving email marketing communications from Advith ITeC, they shall
                                    let Advith ITeC know by emailing, or by using the unsubscribe feature in the marketing email they
                                    received.
                                </li>
                                <li>
                                    {' '}
                                    Users may make changes and updates to the information provided by them on the Services. Any changes they
                                    make through the Services shall be updated by Advith ITeC and will be reflected on the Services.
                                </li>
                                <li>
                                    {' '}
                                    In addition, Advith ITeC will not disclose a User’s personal information to third parties for the third
                                    party's direct marketing purposes if they have received and processed a request from the Users that
                                    their personal information not be shared with third parties for that purpose.
                                </li>
                                <li>
                                    {' '}
                                    All the changes that Users require and request Advith ITeC to make may not be effective immediately.
                                    Advith ITeC will endeavor to comply with the request(s) as soon as reasonably practicable. If Users
                                    opt-out of receiving marketing-related messages from Advith ITeC, Advith ITeC may still send them
                                    important administrative messages which the User cannot opt-out from receiving.
                                </li>
                                <li>
                                    To review, correct, update, suppress, delete or otherwise limit Advith ITeC’s use of Users’ personal
                                    information that has been previously provided to them, the users must email, call or write to the
                                    customer service personnel and clearly describe the request. The request must clearly state what
                                    information the Users would like to change, suppress or limit. Advith ITeC will try its best to comply
                                    with such requests, however, if certain information by their inherent nature are not capable of
                                    change/removal then such information shall not be removed or changed and Advith ITeC shall not be held
                                    responsible/liable for the non-compliance. Further, certain information is mandated and necessary to be
                                    retained for record keeping purposes and the same shall be so retained irrespective of a request to the
                                    contrary.
                                </li>
                            </ol>
                            <ul className="pl-15 fW600">
                                <li>Retention Period</li>
                            </ul>
                            Data collected by Advith ITeC shall be retained for the period necessary to fulfill the purposes outlined in
                            this Policy, in part or in full, unless a longer retention period is required or permitted by law.
                            <ul className="pl-15 fW600">
                                <li>Contacting us</li>
                            </ul>
                            Any grievance, questions, clarifications or assistance on the usage of the Services and/or the Website shall be
                            emailed to the grievance officer at
                            <Typography variant="body2" className={classes.fontFamilyRubik}>
                                support@advithitec.in{' '}
                            </Typography>
                            <Typography variant="body2" className={classes.fontFamilyRubik}>
                                Or to the below postal address-
                            </Typography>
                            <Typography variant="body2" className={classes.fontFamilyRubik}>
                                Advith ITeC Private Limited{' '}
                            </Typography>
                            <Typography variant="body2" className={classes.fontFamilyRubik}>
                                No. 72/1, 1st Floor,{' '}
                            </Typography>
                            <Typography variant="body2" className={classes.fontFamilyRubik}>
                                Jnanodaya School Road, Shankara Park,{' '}
                            </Typography>
                            <Typography variant="body2" className={classes.fontFamilyRubik}>
                                Shankarpuram, Bangalore 560 004{' '}
                            </Typography>
                            <ul className="pl-15 fW600">
                                <li>Other Sites</li>
                            </ul>
                        </Typography>
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            User must comply with any applicable third party terms of agreement when using the Website. Advith ITeC has no
                            control over and accepts no responsibility for the content of any third party links from the Website. The linked
                            websites or mobile applications are provided for the User’s convenience without any warranty, express or
                            implied, for the information provided within them. Advith ITeC does not provide any endorsement or
                            recommendation of any link of a third party website or mobile application. The terms and conditions, terms of
                            use and privacy policies of those third party website or mobile applications will apply to User. Advith ITeC
                            shall not be liable for any queries, concerns or complaints about such third party website or mobile
                            applications. It is the Users’ responsibility to take precautions to ensure that whatever is selected for use is
                            free of viruses or other items of a destructive nature.
                            <ul className="pl-15 fW600">
                                <li>Third Party Advertising Vendors</li>
                            </ul>
                            The online and email advertising-related vendors of Advith ITeC may use pixel tags, web beacons, clear GIFs or
                            other similar technologies in connection with the Services to help manage the online and email advertising
                            campaigns and strengthen the effectiveness of such campaigns. For example, if a vendor has placed a unique
                            cookie on a User’s device, the vendor may use pixel tags, web beacons, clear GIFs or other similar technologies
                            to recognize the cookie during such User’s visit to their website or app and to learn which of Advith ITeC’s
                            online advertisements may have brought the User to their websites or apps, and the vendor may provide Advith
                            ITeC with such information for their use.
                            <ul className="pl-15 fW600">
                                <li>Changes to the Policy </li>
                            </ul>
                            Advith ITeC reserves the right to change, amend, modify or alter this Policy, from time to time, at its sole
                            discretion. The Users are advised to look at the “Last Updated” legend on the Services to see when this Policy
                            was last revised. Changes made to this Policy will become effective when they are posted on the Services. The
                            Users’ use of the Services following these changes shall mean that they have accepted the revised Policy.
                        </Typography>
                        <Typography variant="body2" className={classes.fontFamilyRubik}>
                            Last updated: 18th June, 2021
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.btnPrivacy}>
                    {/* <Button onClick={handleOk} variant="outlined" color="primary" size="small" className={classes.button}>
                        Go Back
                    </Button> */}
                    <Button onClick={handlePolicyClose} variant="contained" color="primary" size="small" className={classes.button}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
